import { useState } from 'react';
import { Link } from 'react-router-dom';
import { expertiseItems } from '../../data';
import './Expertise.css';

function PlusIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="14" height="14">
      <line x1="12" y1="5"  x2="12" y2="19" />
      <line x1="5"  y1="12" x2="19" y2="12" />
    </svg>
  );
}

function Expertise({ onOpenModal }) {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => setOpenIndex(openIndex === i ? -1 : i);

  return (
    <section className="expertise" id="expertise">
      <span className="sec-pre rv">What We Do</span>
      <h2 className="sec-h rv">Strategies that <em>protect, grow,</em> and preserve your wealth</h2>

      <div className="exp-list rv">
        {expertiseItems.map((item, i) => (
          <div key={i} className={`exp-item${openIndex === i ? ' open' : ''}`}>

            <div className="exp-head" onClick={() => toggle(i)}>
              <span className="exp-num">{item.num}</span>
              <span className="exp-title">{item.title}</span>
              <div className="exp-toggle">
                <PlusIcon />
              </div>
            </div>

            <div className="exp-body">
              <div className="exp-inner">
                <p>{item.body}</p>
                <div className="exp-actions">
                  <Link to={`/services/${item.slug}`} className="exp-btn-outline">Read More</Link>
                  <a href="#" className="exp-btn-gold" onClick={(e) => { e.preventDefault(); onOpenModal(); }}>Book a Consultation</a>
                </div>
              </div>
            </div>

          </div>
        ))}
      </div>
    </section>
  );
}

export default Expertise;
